import { useNavigate } from 'react-router-dom';
import { ArrowUp, Crown } from 'lucide-react';
import { getSettingsPath } from '../../utils/paths';

interface UpgradePromptProps {
  currentTier?: string;  // Optional since it's not used in the component
  limitType: string;
  proValue: string;
  compact?: boolean;
}

export function UpgradePrompt({ limitType, proValue, compact = false }: UpgradePromptProps) {
  const navigate = useNavigate();

  if (compact) {
    return (
      <div className="flex items-center gap-2 p-3 rounded-lg bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/30">
        <ArrowUp className="w-4 h-4 text-purple-400 flex-shrink-0" />
        <p className="text-sm text-gray-300 flex-1">
          Upgrade to Pro for {proValue} {limitType}
        </p>
        <button
          onClick={() => navigate(getSettingsPath('subscription'))}
          className="text-sm font-medium text-purple-400 hover:text-purple-300 cursor-pointer"
        >
          Upgrade
        </button>
      </div>
    );
  }

  return (
    <div className="p-4 rounded-xl bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/30">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-purple-500/20">
          <ArrowUp className="w-5 h-5 text-purple-400" />
        </div>
        <div className="flex-1">
          <p className="font-medium text-white mb-1">
            You've reached your {limitType} limit
          </p>
          <p className="text-sm text-gray-400 mb-3">
            Upgrade to Pro for {proValue} {limitType.includes('ticker') ? 'tickers' : limitType.includes('history') ? 'history' : limitType.includes('watchlist') ? 'watchlists' : 'alerts'}
          </p>
          <button
            onClick={() => navigate(getSettingsPath('subscription'))}
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-lg text-sm hover:opacity-90 transition-opacity cursor-pointer"
          >
            <Crown className="w-4 h-4" />
            Upgrade to Pro
          </button>
        </div>
      </div>
    </div>
  );
}

// Inline upgrade link for tight spaces
export function UpgradeLink({ text = 'Upgrade' }: { text?: string }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(getSettingsPath('subscription'))}
      className="text-purple-400 hover:text-purple-300 text-sm font-medium inline-flex items-center gap-1 cursor-pointer"
    >
      <Crown className="w-3 h-3" />
      {text}
    </button>
  );
}
